import React from 'react';
import PropTypes from 'prop-types';
import { createCategoryStructure } from '../lib/util';
import './CatalogSidebar.css';
import CatalogSidebarItem from './CatalogSidebarItem';

const CatalogSidebar = (props) => {
  const {
    extraClass, categories, products, location, toggleMobileModal,
  } = props;
  const structure = createCategoryStructure({
    categories,
    products,
    assignProduct: false,
  });
  return (
    <aside className={`column sidebar menu ${extraClass}`}>
      <ul className="menu-list">
        {structure.map((elem, index) => (
          <CatalogSidebarItem
            key={`sidebar-item-${index}`}
            data={elem}
            level={1}
            parentPath="/catalog"
            categories={categories}
            location={location}
            toggleMobileModal={toggleMobileModal}
          />
        ))}
      </ul>
    </aside>
  );
};

CatalogSidebar.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  extraClass: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  toggleMobileModal: PropTypes.func,
};

CatalogSidebar.defaultProps = {
  extraClass: '',
  location: {
    pathname: '/catalog',
  },
  toggleMobileModal: () => {},
};

export default CatalogSidebar;



// WEBPACK FOOTER //
// ./src/components/CatalogSidebar.js